import LearnShow from "../components/learn/Show";

export default [
  { name: 'Learn', path: '/learn', component: LearnShow,  }
]
